import { Stack } from '@piwikpro/ui-components';
import React from 'react';
import { useAppSelector } from '../hooks';
import { selectOngoingIncident } from '../incidentSlice';
import { AffectedComponent } from '../model';
import { severity2icon, severity2msg } from '../helpers';

const OngoingIncidentInfo: React.FC = () => {
  const incident = useAppSelector(selectOngoingIncident);

  return (
    <>
      <div className="wrapper-inside">
        {incident.affected.length ? (
          incident.affected.map((ac: AffectedComponent) => (
            <Stack
              key={incident.id + ac.name + ac.severity}
              verticalAlignment="center"
              spacing="default"
            >
              <Stack.Item>
                <div className="m-4">{severity2icon[ac.severity]}</div>
              </Stack.Item>
              <Stack.Item>
                <strong>{severity2msg[ac.severity]}</strong> : {ac.name}
              </Stack.Item>
            </Stack>
          ))
        ) : (
          <Stack key="no-incident" verticalAlignment="center" spacing="default">
            <Stack.Item>
              <div className="m-4">{severity2icon.ok}</div>
            </Stack.Item>
            <Stack.Item>All systems operational</Stack.Item>
          </Stack>
        )}
      </div>
    </>
  );
};

export { OngoingIncidentInfo };
